module.exports = __webpack_public_path__ + "img/google-pay-mark_800-cropped.d8b1917a.svg";